import React from 'react';
import { Bar } from 'react-chartjs-2';
import { SecurityThreatSummary, TrafficType } from '../../services/webFilter.service';
import WfDiffArrow from './WfDiffArrow';

interface Props {
  data: SecurityThreatSummary;
  trafficType: TrafficType;
  pageIndicator: string; // (1/4) ~ (4/4) 같은 문자열
  isPdfMode?: boolean;
}

const ICON: Record<TrafficType, string> = { web: '🛡️', netapp: '🔒' };

const WfSecurityThreatSummary: React.FC<Props> = ({ data, trafficType, pageIndicator, isPdfMode }) => {
  const totalRow = data.byAccount.find((r) => r.accountType === '총합') ?? { prevCount: 0, currentCount: 0, diffText: '-' };
  const trafficLabel = trafficType === 'web' ? '웹사이트' : '넷앱/HTTPS';

  return (
    <div className={`wf-section-card ${isPdfMode ? 'pdf-page-break' : ''}`}>
      {isPdfMode && (
        <h2 className="wf-pdf-section-title">
          {ICON[trafficType]} 보안 위협 웹/넷앱 차단 현황 {pageIndicator}
        </h2>
      )}
      <h3>■ 보안 위협 {trafficLabel} 차단 현황</h3>

      <div className="wf-threat-row">
        <div className="wf-threat-tables">
          <div className="wf-chart-title">[보안위협{trafficLabel} 차단 건수 전월 대비 현황]</div>
          <table className="wf-data-table">
            <thead>
              <tr>
                <th rowSpan={2}>구분</th>
                <th colSpan={2}>건수</th>
                <th rowSpan={2}>증감</th>
              </tr>
              <tr>
                <th>전월</th>
                <th>당월</th>
              </tr>
            </thead>
            <tbody>
              {data.byAccount.map((r) => (
                <tr key={r.accountType} className={r.accountType === '총합' ? 'wf-total-row' : ''}>
                  <td>{r.accountType}</td>
                  <td>{r.prevCount.toLocaleString()}</td>
                  <td>{r.currentCount.toLocaleString()}</td>
                  <td><WfDiffArrow diffText={r.diffText} /></td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="wf-chart-title" style={{ marginTop: '1.5rem' }}>
            [보안위협{trafficLabel} 카테고리별 차단 건수 전월 대비 현황]
          </div>
          <table className="wf-data-table">
            <thead>
              <tr>
                <th rowSpan={2}>구분</th>
                <th colSpan={2}>건수</th>
                <th rowSpan={2}>증감</th>
              </tr>
              <tr>
                <th>전월</th>
                <th>당월</th>
              </tr>
            </thead>
            <tbody>
              {data.byCategory.map((r) => (
                <tr key={r.category}>
                  <td>{r.category}</td>
                  <td>{r.prevCount.toLocaleString()}</td>
                  <td>{r.currentCount.toLocaleString()}</td>
                  <td><WfDiffArrow diffText={r.diffText} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="wf-threat-chart">
          <div className="wf-chart-title">[총 차단 건수 전월 대비 현황]</div>
          <div className="wf-chart-wrapper" style={{ height: 360 }}>
            <Bar
              data={{
                labels: ['전월', '당월'],
                datasets: [
                  {
                    label: '건수',
                    data: [totalRow.prevCount, totalRow.currentCount],
                    backgroundColor: ['rgba(149, 165, 166, 0.8)', 'rgba(52, 152, 219, 0.8)'],
                  },
                ],
              }}
              options={{
                responsive: true,
                maintainAspectRatio: false,
                plugins: { legend: { display: false } },
                scales: { y: { beginAtZero: true, title: { display: true, text: '건수' } } },
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WfSecurityThreatSummary;
